/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-console */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { toastError, toastSuccess } from '../../../redux/actions/alertActions';
import userActions from '../../../redux/actions/userActions';
import userServices from '../../../redux/services/userServices';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',
    marginTop: '15px',
  },
  input: {
    color: 'white',
  },
  rootField: {
    background: 'white',
  },
}));

const LogInForm = (props) => {
  const { changeTab } = props;
  const [email, setemail] = useState('');
  const classes = useStyles();

  const handleSubmit = () => {
    if (email) {
      userServices.forgotPassword(email);
      toastSuccess('Password recovery link sended with success');
    } else {
      toastError('Please provide an email and a password');
    }
  };

  return (
    <>
      <Typography component="h1" variant="h5">
        <FormattedMessage id="Login.recoverPassword" defaultMessage="Password Recovery" />
      </Typography>
      <Grid container style={{ width: '100%' }}>
        <Grid xs="12">
          <FormControl className={classes.textField} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              <FormattedMessage id="Login.email" defaultMessage="Email" />
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type="text"
              value={email}
              className={classes.rootField}
              onChange={(e) => setemail(e.target.value)}
              labelWidth={120}
              InputProps={{
                className: classes.input,
              }}
            />
          </FormControl>
        </Grid>
        <Grid xs="12">
          <Button color="primary" onClick={() => handleSubmit()} variant="contained" style={{ width: '100%', marginTop: '20px' }}>
            <FormattedMessage id="Common.signin" defaultMessage="Send me an email to recover password" />
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item>
          <div
            style={{ cursor: 'pointer', color: '#1D3A74', marginTop: '10px' }}
            onClick={() => changeTab(0)}
          >
            Return to Login
          </div>
        </Grid>
      </Grid>
    </>
  );
};

LogInForm.propTypes = {
  changeTab: PropTypes.func.isRequired,
};

function mapState(state) {
  const {
    loggingIn,
    codeLoggingIn,
    requestNewPassword,
    newPassword,
  } = state.authentication;
  return {
    loggingIn,
    codeLoggingIn,
    requestNewPassword,
    newPassword,
  };
}

const actionCreators = {
  login: userActions.login,
  forgotPassword: userActions.forgotPassword,
  logout: userActions.logout,
};

const connectedLogin = connect(mapState, actionCreators)(LogInForm);

export default reduxForm({
  form: 'log_in_form',
})(connectedLogin);
